
const ConsultingMethodology = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Meine Methodik
          </span>
          <h2 className="animate-fade-in mb-6" style={{ animationDelay: '100ms' }}>
            Der Weg zu nachhaltiger Entwicklung: Menschenzentrierter 3-Phasen-Prozess
          </h2>
          <p className="text-joerg-600 text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '200ms' }}>
            Mein Consulting-Ansatz stellt den Menschen in den Mittelpunkt und folgt einem klaren, aber flexiblen Prozess. 
            Gerade in Zeiten zunehmender KI-Integration sind Empathie und emotionale Intelligenz die entscheidenden Faktoren für 
            nachhaltige Unternehmensführung und echte Mitarbeiterbindung.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col gap-12 relative">
            {/* Connection line */}
            <div className="absolute left-8 top-12 bottom-12 w-1 bg-primary/20 hidden md:block" style={{ marginLeft: "3px" }}></div>
            
            {/* Phase 1 */}
            <div className="flex flex-col md:flex-row gap-6 animate-fade-in" style={{ animationDelay: '0ms' }}>
              <div className="flex-shrink-0 flex items-start">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary text-white font-bold text-2xl shadow-md z-10">
                  1
                </div>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-soft flex-grow">
                <h3 className="text-xl font-semibold mb-4 text-joerg-800">Verstehen & Vernetzen</h3>
                <p className="text-joerg-600 mb-4">
                  Wir beginnen mit dem Aufbau einer Vertrauensbasis und dem tiefen Verständnis Ihrer spezifischen Situation. 
                  Durch dialogorientierte Gespräche und einfühlsame Analysen erfassen wir die individuellen Bedürfnisse Ihrer 
                  Mitarbeiter und die einzigartigen Herausforderungen Ihres Unternehmens.
                </p>
                <div className="bg-joerg-50 p-4 rounded-lg">
                  <p className="font-medium text-joerg-800 mb-1">Diese Phase schafft:</p>
                  <ul className="text-joerg-600 list-disc pl-5 space-y-1">
                    <li>Ein tiefes Verständnis der aktuellen Teamdynamik</li>
                    <li>Identifikation verborgener Potenziale und Ressourcen</li>
                    <li>Eine vertrauensvolle Basis für den gemeinsamen Entwicklungsprozess</li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Phase 2 */}
            <div className="flex flex-col md:flex-row gap-6 animate-fade-in" style={{ animationDelay: '150ms' }}>
              <div className="flex-shrink-0 flex items-start">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary text-white font-bold text-2xl shadow-md z-10">
                  2
                </div>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-soft flex-grow">
                <h3 className="text-xl font-semibold mb-4 text-joerg-800">Befähigen & Begleiten</h3>
                <p className="text-joerg-600 mb-4">
                  In dieser Phase entwickeln wir gemeinsam individuelle Wachstumspfade für Ihre Führungskräfte und Teams. 
                  Durch maßgeschneiderte Workshops, Coaching und Dialog schaffen wir Räume für emotionales Wachstum, 
                  Selbstreflexion und die Entfaltung authentischer Führungsqualitäten.
                </p>
                <div className="bg-joerg-50 p-4 rounded-lg">
                  <p className="font-medium text-joerg-800 mb-1">Diese Phase fördert:</p>
                  <ul className="text-joerg-600 list-disc pl-5 space-y-1">
                    <li>Entwicklung emotionaler Intelligenz bei Führungskräften</li>
                    <li>Stärkung der Resilienz und Selbstfürsorge im Team</li>
                    <li>Verbesserung der Kommunikations- und Konfliktfähigkeit</li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Phase 3 */}
            <div className="flex flex-col md:flex-row gap-6 animate-fade-in" style={{ animationDelay: '300ms' }}>
              <div className="flex-shrink-0 flex items-start">
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary text-white font-bold text-2xl shadow-md z-10">
                  3
                </div>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-soft flex-grow">
                <h3 className="text-xl font-semibold mb-4 text-joerg-800">Verankern & Verselbständigen</h3>
                <p className="text-joerg-600 mb-4">
                  Der entscheidende Schritt ist die nachhaltige Integration der neu entwickelten Fähigkeiten in den Arbeitsalltag. 
                  Wir etablieren Selbstreflexionsroutinen und Feedback-Kulturen, die eine kontinuierliche Weiterentwicklung auch nach 
                  dem Consulting-Prozess sicherstellen.
                </p>
                <div className="bg-joerg-50 p-4 rounded-lg">
                  <p className="font-medium text-joerg-800 mb-1">Diese Phase bewirkt:</p>
                  <ul className="text-joerg-600 list-disc pl-5 space-y-1">
                    <li>Nachhaltige Verbesserung des Arbeitsklimas</li>
                    <li>Gesteigerte Mitarbeiterbindung und reduzierte Fluktuation</li>
                    <li>Senkung von Fehlzeiten und Prävention von Burnout</li>
                    <li>Als Folgeeffekt: Positive Auswirkung auf Unternehmensperformance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultingMethodology;
